import { Box, Container, Flex, createStyles } from '@mantine/core';
import useTranslation from 'next-translate/useTranslation';

import { Routes } from '~/domains/common/constants/routes';
import { useIsMobile } from '~/domains/common/hooks/mediaQueries';
import { ButtonLink } from '~/domains/design-system/Button';
import dt from '~/testing';

export function ChannelDetailPage({ children }: { children: React.ReactNode }) {
  const isMobile = useIsMobile();

  if (isMobile) {
    return (
      <Flex direction="column" /* eslint-disable-line local-rules/use-theme-tokens */ gap={16} pb={24}>
        {children}
      </Flex>
    );
  }

  return (
    <Container size={1280} /* eslint-disable-line local-rules/use-theme-tokens */ px={24} py={24} h="100%">
      <Flex direction="row" /* eslint-disable-line local-rules/use-theme-tokens */ gap="40px" h="100%">
        {children}
      </Flex>
    </Container>
  );
}

function ChannelDetailPageAside({ children }: { children: React.ReactNode }) {
  const isMobile = useIsMobile();

  return (
    <Box maw={isMobile ? '100%' : '393px'} sx={{ width: '100%', flexShrink: 0 }}>
      {children}
    </Box>
  );
}

function ChannelDetailPageContent({ children }: { children: React.ReactNode }) {
  const isMobile = useIsMobile();

  if (isMobile) {
    return (
      <Container fluid w="100%">
        <Flex direction="column" /* eslint-disable-line local-rules/use-theme-tokens */ gap={16}>
          {children}
        </Flex>
      </Container>
    );
  }

  return (
    <Flex direction="column" /* eslint-disable-line local-rules/use-theme-tokens */ gap={16} w="100%">
      {children}
    </Flex>
  );
}

const useStyles = createStyles((theme) => ({
  floatingButton: {
    display: 'flex',
    position: 'fixed',
    bottom: '20px',
    right: '20px',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 100,
    padding: 0,
    height: '56px',
    width: '56px',

    backgroundColor: theme.colors.blue[5],
    color: theme.colors.gray2[7],
    borderRadius: /* eslint-disable-line local-rules/use-theme-tokens */ '16px',
    boxShadow: '0px 8px 16px 0px rgba(0, 0, 0, 0.6)',
  },
}));

function CreateContestButton() {
  const { t } = useTranslation('channel');
  const isMobile = useIsMobile();
  const { classes } = useStyles();

  if (isMobile) {
    return (
      <ButtonLink
        href={Routes.createAContest()}
        className={classes.floatingButton}
        aria-label={t('contests.create')}
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="34" height="34" fill="none">
          <g clipPath="url(#a)">
            <path
              stroke="#1A1C1E"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="3"
              d="M17 8.515v16.97M8.515 17h16.97"
            />
          </g>
          <defs>
            <clipPath id="a">
              <path fill="#fff" d="M.03 17 17 .03 33.97 17 17 33.97z" />
            </clipPath>
          </defs>
        </svg>
      </ButtonLink>
    );
  }

  return (
    <ButtonLink
      href={Routes.createAContest()}
      variant="secondary-fill"
      size="large"

      data-test-id={dt.channel.channelDetailPage.createaContestButton}
    >
      {t('contests.create')}
    </ButtonLink>
  );
}

ChannelDetailPage.Aside = ChannelDetailPageAside;
ChannelDetailPage.Content = ChannelDetailPageContent;
ChannelDetailPage.CreateContestButton = CreateContestButton;
